import { atKeys, getGlobalThis } from "@de-xima/xima-common-js-lang";

/**
 * Gets the global JQuery object. Use only when necessary, such as when interacting
 * with PrimeFaces. Otherwise, use native APIs.
 * @returns {JQueryStatic} The global JQuery object.
 * @throws If JQuery is not found.
 */
export function getJq() {
  const jq = atKeys(getGlobalThis(), ["jQuery"]) ?? atKeys(getGlobalThis(), ["$"]);
  if (typeof jq !== "function") {
    throw new Error("jQuery not found");
  }
  return /** @type {JQueryStatic} */ (jq);
}
